import { Configuration } from "@freightsimple/generated-dashboard-openapi-client/runtime";
import { UsersApi } from "@freightsimple/generated-dashboard-openapi-client/apis/UsersApi";
import { useSelector } from "react-redux";
import type { RootState } from "@/store";
import { getConfig } from "@/Apis/getConfig";

export function useUsersApi(): UsersApi {
  // This avoid circular dependency with useAuthentication
  const accessToken =
    useSelector((state: RootState) => state.authentication.accessToken) ?? "";

  return new UsersApi(
    new Configuration({ ...getConfig(), accessToken: accessToken }),
  );
}
